import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import { getCurrentUser } from 'helpers/Utils';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    ISSUES_RESOLUTIONS_FETCH_ITEM,
    ISSUES_RESOLUTIONS_ADD_ITEM,
    ISSUES_RESOLUTIONS_DELETE_ITEM
} from './actions_def';
import {
    getIssuesResolutionItemSuccess,
    getIssuesResolutionItemError,
    addIssuesResolutionItemSuccess,
    addIssuesResolutionItemError,
    deleteIssuesResolutionItemSuccess,
    deleteIssuesResolutionItemError


} from './actions';


const apiUrl = servicePath;


const getIssuesResolutionItemRequest = async (payload) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/resolutions/' + payload.resolutionId, { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => (
                    {
                        id: item.rfc_id,
                        title: item.rfc_title,
                        date: moment(item.date_created).format("Do MMM YYYY"),
                        change_date: moment(item.date_modified).format("Do MMM YYYY (hh:mm)"),
                        end_date: moment(item.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
                        resolution: item.rfc_resolution,
                        resolutionColor: 'primary'
                    }
                )
                )
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getIssuesResolutionItem() {
    try {
        const response = yield call(getIssuesResolutionItemRequest);
        yield put(getIssuesResolutionItemSuccess(response));
    } catch (error) {
        yield put(getIssuesResolutionItemError(error));
    }
}


const addIssuesResolutionItemRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    console.log(item);
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        var _user = getCurrentUser(); // JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'post',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _resolution = 1;
        switch (item.resolution) {
            case "PENDING": _resolution = 1; break;
            default: _resolution = 1;
        };

        let _sendingPayload = {
            Name: item.name,
            ProjectId: item.projectId,
            Notes: item.description ? item.description : ' ',
            DueDate: item.due_date ? item.due_date : new Date(),
            ReleaseDate: item.due_date ? item.due_date : new Date(),
        };

        // console.log(_sendingPayload, getAccessToken());
        instance.post('/resolutions/',
            _sendingPayload,
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.resolution !== 200 && response.data.resolution !== 201) {
                        fail(response.data);
                    }
                    else {
                        success(response.data);
                    }
                }
            }).catch((error) => {
                console.log(error)
            });;
    })
        .then((response) => response)
        .catch((error) => error);
};

function* addIssuesResolutionItem({ payload }) {
    // // console.log(payload);;
    try {
        const response = yield call(addIssuesResolutionItemRequest, payload);
        console.log('Response :', response, response.resolution === "fail")
        if (response.resolution !== "fail") {
            yield put(addIssuesResolutionItemSuccess(response));
        }
        else {
            yield put(addIssuesResolutionItemError(response));
        }
    } catch (error) {
        yield put(addIssuesResolutionItemError(error));
    }
}


const deleteIssuesResolutionRequest = async (item) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {
        console.log(item)
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        instance.delete('/resolutions/' + item.resolutionId,
            { crossdomain: true })
            .then(response => {
                if (response.data) {
                    if (response.data.resolution === "fail") {
                        fail(response.data);
                    }
                    else if (response.data.resolution === "success" || response.data.resolution === "ok") {
                        success(response.data);
                    }
                    else {
                        console.log('Inconsistent behaviour', response.data.resolution);
                    }
                }
            }).catch((error) => {
                console.log(error);
            });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteIssuesResolutionItem({ payload }) {
    // console.log(payload);
    try {
        const response = yield call(deleteIssuesResolutionRequest, payload);
        console.log('Response :', response, response.resolution === "fail")
        if (response.resolution !== "fail") {
            yield put(deleteIssuesResolutionItemSuccess(response));
        }
        else {
            yield put(deleteIssuesResolutionItemError(response));
        }
    } catch (error) {
        yield put(addIssuesResolutionItemError(error));
    }
}


export function* watchFetchItem() {
    yield takeEvery(ISSUES_RESOLUTIONS_FETCH_ITEM, getIssuesResolutionItem);
}

export function* watchAddItem() {
    yield takeEvery(ISSUES_RESOLUTIONS_ADD_ITEM, addIssuesResolutionItem);
}
export function* watchDeleteItem() {
    yield takeEvery(ISSUES_RESOLUTIONS_DELETE_ITEM, deleteIssuesResolutionItem);
}


export default function* rootSaga() {
    yield all([
        fork(watchAddItem),
        fork(watchFetchItem),
        fork(watchDeleteItem),
    ]);
}
